import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const YIL_LISTESI = Array.from({ length: 16 }, (_, i) => 2015 + i); // 2015–2030

export default function YilDropdown({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  function handleOpen() {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setPos({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX, width: rect.width });
    }
    setOpen(p => !p);
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={handleOpen}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-4 py-2 rounded-xl text-sm flex items-center gap-2 min-w-[90px] justify-between transition-colors"
      >
        <span>{value}</span>
        <span className="text-white text-xs opacity-80">{open ? '▲' : '▼'}</span>
      </button>
      {open && createPortal(
        <div
          style={{ position: 'absolute', top: pos.top + 4, left: pos.left, width: Math.max(pos.width, 100), zIndex: 9999 }}
          className="bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden"
          onMouseDown={e => e.stopPropagation()}
        >
          <div className="max-h-60 overflow-y-auto py-1">
            {YIL_LISTESI.map(yil => (
              <button
                key={yil}
                onClick={() => { onChange(yil); setOpen(false); }}
                className={
                  'w-full text-left px-4 py-2 text-sm font-semibold transition-colors ' +
                  (yil === value
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700')
                }
              >
                {yil}
              </button>
            ))}
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
